


















































import { Component, Vue, Prop } from "vue-property-decorator";
import { PowerPlanEvent, PowerPlanEventType } from "@/services/powerPlans/types";
import { createEvent, updateEvent } from "@/services/powerPlans/powerPlanEventService";
import PowerPlanEventSchedule from "@/components/powerPlans/PowerPlanEventSchedule.vue";
import { RecurenceEnum } from "@/services/posts/types";
import i18n from "@/i18n";
import { ValidationModel, ValidationType } from "@/services/validation/types";
import { validateForm } from "@/services/validation/validationService";
import validate from "@/directives/validate";
import moment from "moment";

@Component({
    components: { PowerPlanEventSchedule },
    directives: { validate }
})
export default class powerPlanEventCreateAndUpdate extends Vue {
        @Prop() powerPlanId!: string;
        event = {
            fromDate: new Date().toDateString(),
            toDate: "",
            fromTime: "08:00",
            toTime: "16:00",
            neverending: true,
            allDay: true,
            recurenceType: RecurenceEnum.daily,
            recurenceValues: [] as Number[],
            yearly: "",
            type: PowerPlanEventType.On
        } as PowerPlanEvent;

        saveClicked = false;
        isEdit = false;
        scheduleValid = false;
        eventTypes: any = Object.keys(PowerPlanEventType).filter(key => !isNaN(Number(key))).map(key => ({
            name: i18n.t(`powerPlanEvent.${PowerPlanEventType[Number(key)]}`),
            id: key
        }));

    validators = {
        name: {
            rules: [
                { type: ValidationType.Required }
            ]
        } as ValidationModel
    };

    onScheduleUpdated(isValid: boolean) {
        this.scheduleValid = isValid;
    }

    async save() {
        if (this.saveClicked) return;

        this.saveClicked = true;

        (this.$refs.eventSchedule as any).checkIfFormIsValid();
        if (!this.scheduleValid || !await validateForm([this.validators])) {
            this.saveClicked = false;
            return;
        }

        this.formatTime();
        this.event.powerPlanId = this.powerPlanId;

        if (!this.event.id) {
            createEvent(this.event as PowerPlanEvent).then((id: any) => {
                this.event.id = id;
                this.$emit("reload");
                this.saveClicked = false;
            });
        } else {
            updateEvent(this.event.id, this.event).then(() => {
                this.$emit("reload");
                this.saveClicked = false;
            });
        }
        this.resetForm();
        this.$bvModal.hide("modal-powerPlanEventCreateAndUpdate");
    }

    formatTime() {
        if (this.event.fromDate.length === 0) { return; }

        const startDate = new Date(this.event.fromDate);

        if (this.event.fromTime && this.event.fromTime.length > 0) {
            const startTime = this.event.fromTime.split(":");
            const startDateTime = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), Number(startTime[0]), Number(startTime[1]));
            this.event.fromTime = moment(startDateTime).format("YYYY-MM-DDTHH:mm:ss");
        }

        if (this.event.toTime && this.event.toTime.length > 0) {
            const endTime = this.event.toTime.split(":");
            const endDateTime = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), Number(endTime[0]), Number(endTime[1]));
            this.event.toTime = moment(endDateTime).format("YYYY-MM-DDTHH:mm:ss");
        }
    }

    resetForm() {
        this.isEdit = false;
        this.event = {
            fromDate: new Date().toDateString(),
            toDate: "",
            fromTime: "08:00",
            toTime: "16:00",
            neverending: true,
            allDay: true,
            recurenceType: RecurenceEnum.daily,
            recurenceValues: [] as Number[],
            yearly: "",
            type: PowerPlanEventType.On
        } as PowerPlanEvent;
    }
}
